import { useEffect, useState } from "react";
import {
  deleteContact,
  getContactLinks,
  postContactLinks,
  updateContact,
} from "../../services/contactApi";
import "./contactlinks.css";
import { toast } from "react-toastify";

const initialState = {
  vip: "",
  forid: "",
  affliate: "",
  customer: "",
  telegram: "",
};

export default function AdminContact() {
  const [form, setForm] = useState(initialState);
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const token = localStorage.getItem("token");

  const isEdit = !!contact?._id;
  console.log(form, Object.keys(form));
  const fetchContacts = async () => {
    try {
      const res = await getContactLinks();
      if (res?.data) {
        setContact(res.data);
        setForm(res.data);
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchContacts();
  }, []);

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = async () => {
    setSubmitting(true);
    setSuccess(false);
    const { vip, affliate, customer, forid, telegram } = form;
    if (!vip || !affliate || !customer || !forid || !telegram) {
      toast.info("please provide all number");
    }
    const data = {
      vip: vip.trim(),
      affliate: affliate.trim(),
      customer: customer.trim(),
      forid: forid.trim(),
      telegram: telegram.trim(),
    };
    try {
      isEdit
        ? await updateContact(contact._id, data)
        : await postContactLinks(data);

      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      fetchContacts();
      setSubmitting(false);
      setTimeout(() => setSuccess(false), 2500);
    }
  };

  const remove = async () => {
    await deleteContact(contact._id, token);
    setContact(null);
    setForm(initialState);
  };

  if (loading) return <div className="loader"></div>;
  const fields = ["vip", "affliate", "forid", "telegram", "customer"];
  return (
    <div className="admin-container">
      <div className="admin-card">
        <h2>Contact Links</h2>

        {/* {Object.keys(form).map((key) => (
          <div className="input-group" key={key}>
            <input name={key} value={form[key]} onChange={onChange} required />
            <label>{key}</label>
          </div>
        ))} */}

        {fields.map((key) => (
          <div className="input-group" key={key}>
            <input
              name={key}
              value={form[key] || ""}
              onChange={onChange}
              required
            />
            <label>{key}</label>
          </div>
        ))}

        <button
          className={`primary-btn ${success ? "success" : ""}`}
          disabled={submitting}
          onClick={submit}
        >
          {success ? "Saved ✔" : isEdit ? "Update" : "Create"}
        </button>

        {isEdit && (
          <button className="danger-btn" onClick={remove}>
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
